module.exports = __webpack_public_path__ + "static/media/carsin-logo.e71d06ab.png";


/*****************
 ** WEBPACK FOOTER
 ** ./media/carsin-logo.png
 ** module id = 257
 ** module chunks = 0
 **/